module.exports = __webpack_public_path__ + "img/comp_scoretracker.f238e826.jpg";